const DEFAULT_MCP_UI_BASE_URL = '/mcp'
const LOCAL_MCP_UI_BASE_URL = 'http://localhost:7081'
const LOCAL_AI2_UI_BASE_URL = 'http://satels.localhost:4173'

const normalizeBaseUrl = (value: string) => {
  const trimmed = value.trim()
  if (!trimmed) return ''
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed
}

const isLocalhost = () => {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0'
}

const resolveMcpUiBaseFromHost = () => {
  if (typeof window === 'undefined' || isLocalhost()) return ''
  const host = window.location.host
  if (!host.startsWith('platform.')) return ''
  const suffix = host.slice('platform.'.length)
  if (!suffix) return ''
  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:'
  return `${protocol}//ai-reports.${suffix}`
}

export const getMcpUiBaseUrl = () => {
  const base = process.env.REACT_APP_MCP_UI_BASE_URL ||
    resolveMcpUiBaseFromHost() ||
    (isLocalhost() ? LOCAL_MCP_UI_BASE_URL : DEFAULT_MCP_UI_BASE_URL)
  return normalizeBaseUrl(base)
}

export const getAi2UiBaseUrl = () => {
  const base = process.env.REACT_APP_AI2_UI_BASE_URL ||
    process.env.REACT_APP_MCP2_UI_BASE_URL ||
    (isLocalhost() ? LOCAL_AI2_UI_BASE_URL : '')
  return normalizeBaseUrl(base)
}

export const buildMcpUiUrl = (path: string, baseOverride?: string) => {
  const base = baseOverride ? normalizeBaseUrl(baseOverride) : getMcpUiBaseUrl()
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  if (!base) return normalizedPath
  return `${base}${normalizedPath}`
}
